'use client';
import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { createMarketplaceApiPorts, MarketplaceApiPorts } from '@/context/marketplace-api';

export type MarketplaceContextType = {
    api: MarketplaceApiPorts;
};

const defaultState: MarketplaceContextType = {
    api: createMarketplaceApiPorts(),
};

const MarketplaceContext = createContext(defaultState);

export const useMarketplace = () => useContext(MarketplaceContext);
export const useMarketplaceApi = () => useMarketplace().api;

type MarketplaceProviderProps = PropsWithChildren;

export const MarketplaceProvider = ({ children }: MarketplaceProviderProps) => {
    const api = useMemo(() => createMarketplaceApiPorts(), []);

    return <MarketplaceContext.Provider value={{ api }}>{children}</MarketplaceContext.Provider>;
};
